import { AppLocationContext } from "@react-admin/ra-navigation";
import { ReactNode, useMemo } from "react";
import { Layout } from "react-admin";
import { CustomAppBar } from "./CustomAppBar";
import { CustomMenu } from "./CustomMenu";
import { RangerChatSidebar, useChatDrawerWidth } from "./RangerChatSidebar";
import { useCustomHeaderEffect } from "./useCustomHeaderEffect";

export const CustomLayout = ({ children }: { children?: ReactNode }) => {
  const { mainLayoutPadding, headerHeight } = useCustomHeaderEffect();
  const chatDrawerWidth = useChatDrawerWidth();

  const sx = useMemo(() => {
    const sidebarHeight = headerHeight
      ? `calc(100vh - ${headerHeight}px)`
      : "calc(100vh - 3em)";
    return {
      ".RaLayout-content": {
        paddingTop: `${mainLayoutPadding}px`, // should adjust for
        paddingBottom: "75px", // hover save to not overlap. main content
        // the chat drawer is fixed over the right edge; reflow the page beside it
        paddingRight: chatDrawerWidth ? `${chatDrawerWidth}px` : undefined,
      },
      "& .RaSidebar-fixed": {
        height: sidebarHeight,
        top: headerHeight ? `${headerHeight}px` : "3em",
      },
    };
  }, [mainLayoutPadding, headerHeight, chatDrawerWidth]);

  return (
    <AppLocationContext>
      <Layout appBar={CustomAppBar} menu={CustomMenu} sx={sx}>
        {children}
        <RangerChatSidebar />
      </Layout>
    </AppLocationContext>
  );
};
